import { DataService } from 'src/app/shared/services/data.service';
import { environment } from 'src/environments/environment';
import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { RenderService } from 'src/app/shared/services/render.service';
import { ScriptsLoaderService } from 'src/app/shared/services/scripts-loader.service';
import { BaseRequest } from 'src/app/models/requests/baseRequest';
import {
  Router,
} from '@angular/router';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { ConfigService } from 'src/app/shared/services/config/config.service';
import { CurrentPageService } from 'src/app/shared/services/current-page.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { PersonalizationPopup } from '../../personalization-popup/personalization-popup';

@Component({
  selector: 'app-private',
  templateUrl: './private.component.html',
  styleUrls: ['./private.component.scss'],
})
export class PrivateComponent implements OnInit {
  constructor(
    private dataService: DataService,
    private renderService: RenderService,
    private renderer: Renderer2,
    private router: Router,
    private personalizationPopup: MatDialog,
    public loadingService: LoadingService,
    public configService: ConfigService,
    private currentPageService: CurrentPageService
  ) {
  }

  @ViewChild('pageDataContainer') pageDataContainer!: ElementRef;
  openedSidebar: boolean = false;
  showStream: boolean = true;
  generalSettingsData: any;
  popupData: any;
  fullHeightSearch: boolean = true;
  shouldDisplayPopup: boolean = false;
  private currentPageSubscription!: Subscription; // To hold the subscription

  async ngOnInit() {
    // Fetch layout data *First*
    await this.getData(
      environment.apiUrl + '/umbraco/Surface/MainPortalSurface/GetLayoutData'
    );

    // Fetch popup data

    this.currentPageSubscription =
      this.currentPageService.currentPageNodeId$.subscribe((nodeId) => {
        if (nodeId) {
          this.getPopupData(
            environment.apiUrl + '/api/AlertsPopup/GetAlertsPopup',
            nodeId
          );
        }
      });
  }

  toggleSidebar(open: boolean) {
    this.openedSidebar = open;
  }

  getPopupData(url: string, nodeId: number) {
    var request: any = {
      cultureCode: this.dataService.getCultureCode(),
      nodeId: nodeId,
    };

    this.dataService.getDataByToken(url, request).subscribe({
      next: (data) => {
        this.popupData = data;

        // Check popup display after data is loaded
        this.checkPopupDisplay();

        // Bind popups after a small delay
        setTimeout(() => {
          if (this.pageDataContainer && this.pageDataContainer.nativeElement) {
            this.renderService.bindMessagePopups();
          }
        }, 0);
      },
      error: (e) => console.log('getPopupData error: ' + e.status),
    });
  }

  
async getData(url: string): Promise<void> {
  const request: BaseRequest = {
    cultureCode: this.dataService.getCultureCode(),
  };

  try {
    const dataRaw = await firstValueFrom(
      this.dataService.getLayoutData(url, request)
    );

    const data = JSON.parse(dataRaw);
    this.generalSettingsData = data;

    this.fullHeightSearch = !(
      this.generalSettingsData.promotedMessagesSection &&
      this.generalSettingsData.promotedMessagesSection.html &&
      this.generalSettingsData.promotedMessagesSection.html !== ''
    );

    console.log(this.generalSettingsData);

    this.checkPopupDisplay();

    // Wait for DOM to update
    setTimeout(() => {
      if (this.pageDataContainer?.nativeElement) {
        this.renderService.bindMessagePopups();
      }

      if (data.portalGeneralSettingsData?.headStartScriptsValue) {
        this.insertDynamicContent(
          data.portalGeneralSettingsData.headStartScriptsValue,
          'head'
        );
      }

      if (data.portalGeneralSettingsData?.bodyStartScriptsValue) {
        this.insertDynamicContent(
          data.portalGeneralSettingsData.bodyStartScriptsValue,
          'body'
        );
      }
    });

    this.updateTitle();

    if(this.generalSettingsData?.userDetails?.sessionSiteViewType === 1 &&
      this.generalSettingsData?.userDetails?.userType === 2 &&
      localStorage.getItem(AuthService.isPersonalizationPopupOpenedKey) !== "true"
    ) {
        this.personalizationPopup.open(PersonalizationPopup, {
          disableClose: true,
          data: { autoOpened: true },
        });
    }
  } catch (e: any) {
    console.log('getLayoutData error', e?.status);
  }
}

  updateTitle(){
    if (this.currentPageService.pageManagesTitle) {
      return;
    }

    const title = this.generalSettingsData.userDetails.sessionSiteViewType === 1
      ? this.generalSettingsData.portalGeneralSettingsData.studentPortalSiteTitle
      : this.generalSettingsData.portalGeneralSettingsData.staffPortalSiteTitle;
    if(title)
      document.title = title;
  }

  checkPopupDisplay() {
    const currentUrl = this.router.url;
    const sessionType =
      this.generalSettingsData?.userDetails?.sessionSiteViewType;
    const popupData = this.popupData;

    // Ensure popupData is available
    if (!popupData) return;

    // Get the unique key from popupData content
    const popupKey = popupData.key;
    const popupName = `popup_${popupKey}`;
    const snoozeEnabled = popupData?.snooze;
    const displayAfterSeconds = popupData?.displayAfterSeconds || 0;
    const additionalParams = popupData?.additionalParams;
    var whereToDisplay = -1;
    if (additionalParams) {
      whereToDisplay = parseInt(additionalParams.WhereToDisplay);
    }
    if (
      (currentUrl === '/private/' ||
        currentUrl === '/private/home' ||
        currentUrl === '/private/en/home') &&
      (whereToDisplay == 0 || sessionType == whereToDisplay)
    ) {
      // Logic for setting and showing the popup
      setTimeout(() => {
        let cookieValue = cookiesHandle.getCookie(popupName);

        const oneYearInMilliseconds = 365 * 24 * 60 * 60 * 1000; // Convert seconds to milliseconds
        const now = new Date();
        const expires = new Date(now.getTime() + oneYearInMilliseconds);

        if (!cookieValue) {
          // If the cookie does not exist, create it with an empty string
          cookiesHandle.createCookie(
            popupName,
            'wasNotShowenYet',
            expires,
            '/'
          );
        } else if (cookieValue === 'wasNotShowenYet') {
          // If the cookie exists with an empty string, update its value to 'shown'
          cookiesHandle.createCookie(popupName, 'shown', expires, '/');
        }

        cookieValue = cookiesHandle.getCookie(popupName);
        if (snoozeEnabled || (!snoozeEnabled && cookieValue !== 'shown')) {
          // Show the popup based on the snooze setting or cookie value
          this.shouldDisplayPopup = true;
        }
      }, displayAfterSeconds * 1000);
    }
  }

  closePopup() {
    this.shouldDisplayPopup = false;
  }

  private insertDynamicContent(content: string, location: 'head' | 'body'): void {
    let target = location === 'head' ? document.head : document.body;
    let container = this.renderer.createElement('div');
    container.innerHTML = content;

    Array.from(container.childNodes).forEach((node: any) => {
      if (node.nodeName === 'SCRIPT') {
        // Handle <script> separately to ensure it executes
        let script = this.renderer.createElement('script');
        script.text = node.textContent || '';
        
        if (location === 'head') {
          this.renderer.appendChild(target, script);  // End of head
        } else {
          this.renderer.insertBefore(target, script, target.firstChild);  // Start of body
        }
      } else {
        // Insert non-script nodes as-is
        if (location === 'head') {
          this.renderer.appendChild(target, node);  // End of head
        } else {
          this.renderer.insertBefore(target, node, target.firstChild);  // Start of body
        }
      }
    });
  }
}